<style lang="scss">
.header {
  box-shadow: 0 4px 23px 0 rgba(0, 0, 0, 0.09);
  height: 80px;
  display: flex;
  align-items: center;
  padding-left: 5%;
  padding-right: 5%;
  background-color: #b67d72;
  background-image: url(../assets/header_bg.png);
  position: relative;
  &::after {
    content: '';
    width: 100%;
    height: 100px;
    position: absolute;
    left: 0;
    top: 80px;
    background: rgba($color: #000, $alpha: 0.3);
    background: -webkit-linear-gradient(to top, transparent, rgba($color: #000, $alpha: 0.3));
    background: linear-gradient(to top, transparent, rgba($color: #000, $alpha: 0.3));
  }
  .logo {
    max-width: 200px;
    img {
      width: 100%;
    }
  }
  h1 {
    color: #733f10;
    margin: 0;
    padding: 0;
    line-height: 1;
    font-size: 1.6rem;
    text-align: center;
    flex: 1;
  }
  .top-right {
    width: 300px;
    text-align: right;
  }
}
.el-select .el-input .el-select__caret {
  background-color: #a66966;
}
.el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
.el-select .el-input .el-select__caret.is-reverse,
.el-select .el-input .el-select__caret.is-reverse {
  transform: rotateZ(180deg) !important;
}
.el-input__icon {
  line-height: 32px !important;
}
.el-select {
  .el-input__inner {
    border-radius: 20px;
  }
  .el-input__suffix {
    right: 0;
    color: #fff;

    .el-input__icon {
      width: 40px;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      &::before {
        color: #fff;
      }
    }
  }
}

.top-right {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  .right {
    max-width: 40vw;
    display: flex;
    .el-input__inner {
      border-radius: 20px !important
      ;
    }
  }
}
#searchInput {
  display: flex;
}

@media screen and (max-width: 800px) {
  .header {
    .logo {
      margin-right: 0;
    }
    h1,
    #searchInput {
      display: none;
    }
  }
}
</style>
<template>
  <div class="header">
    <div
      class="logo"
      @click="reset"
      style="cursor: pointer"
    >
      <img
        src="../assets/logo.png"
        alt
      />
    </div>
    <h1
      style="cursor: pointer"
      @click="reset"
    >大连商品交易所投资者教育资料</h1>
    <div class="top-right">
      <div class="right">
        <div id="searchInput">
          <el-input
            v-model="keyword"
            placeholder="请输入内容"
          >
            <i
              class="el-icon-search el-input__icon"
              slot="prefix"
            ></i>
          </el-input>
          <div style="width: 10px"></div>
        </div>
        <div>
          <el-select
            v-model="selectValue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    keyword: {
      deep: true,
      immediate: false,
      handler: function (val) {
        this.$emit('search', val);
      }
    },
    selectValue: {
      deep: true,
      immediate: false,
      handler: function (val) {
        this.$emit('category', val);
      }
    }
  },
  data() {
    return {
      keyword: '',
      options: [
        {
          value: '品种交易指南',
          label: '品种交易指南'
        },
        {
          value: '产品与服务指南',
          label: '产品与服务指南'
        },
        {
          value: '合约规则设计报告',
          label: '合约规则设计报告'
        },
        {
          value: '品种问答',
          label: '品种问答'
        }
      ],
      selectValue: ''
    };
  },
  methods: {
    reset() {
      this.$emit('reset');
    }
  },
  mounted() {}
};
</script>